

'use strict';


function open (notification, msg, type) {
    notification.innerHTML = msg;
    notification.dataset.type = type;
    notification.classList.add('active');
}

function close (notification) {
    notification.classList.remove('active');
}

export default function notification (msg, type = 'success') {
    const notification = document.querySelector('.notification');

    open(notification, msg, type);

    notification.addEventListener('click', () => close(notification), { once: true });
}
